import { createClient } from '@/lib/supabase/client';

const EDGE_FUNCTION = 'send-clinical-notification';

async function invokeEmailFunction(type: string, to: string | string[], data: Record<string, unknown>) {
  const supabase = createClient();
  const { error } = await supabase.functions.invoke(EDGE_FUNCTION, {
    body: { type, to, data },
  });
  if (error) {
    console.error(`[ClinicalEmail] Failed to send ${type}:`, error.message);
  }
}

// ─── Alert Escalation ─────────────────────────────────────────────────────────

export interface AlertEscalationPayload {
  to: string | string[];
  alertId: string;
  patientName: string;
  metric: string;
  value: string;
  threshold: string;
  severity: 'critical' | 'warning' | 'info';
  clinicalNote: string;
  actionRequired: string;
  escalatedBy: string;
  sessionId?: string;
}

export async function sendAlertEscalationEmail(payload: AlertEscalationPayload): Promise<void> {
  const { to, ...data } = payload;
  await invokeEmailFunction('alert_escalation', to, data);
}

// ─── Case Handoff ─────────────────────────────────────────────────────────────

export interface CaseHandoffPayload {
  to: string | string[];
  threadId?: string;
  patientCode: string;
  protocol: string;
  handoffFrom: string;
  handoffTo?: string;
  note: string;
  priority: 'low' | 'medium' | 'high' | 'critical';
  msgType: 'note' | 'handoff' | 'alert' | 'update';
}

export async function sendCaseHandoffEmail(payload: CaseHandoffPayload): Promise<void> {
  const { to, ...data } = payload;
  await invokeEmailFunction('case_handoff', to, data);
}

// ─── Protocol Invite ──────────────────────────────────────────────────────────

export interface ProtocolInvitePayload {
  to: string | string[];
  protocolName: string;
  protocolId?: string;
  targetCondition: string;
  durationWeeks: number;
  invitedBy: string;
  patientName?: string;
  sessionCount?: number;
}

export async function sendProtocolInviteEmail(payload: ProtocolInvitePayload): Promise<void> {
  const { to, ...data } = payload;
  await invokeEmailFunction('protocol_invite', to, data);
}
